import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { WhatsAppIcon, useWhatsAppLink } from '../components/WhatsAppButton';

const Gallery = () => {
  const { t } = useTranslation();
  const whatsappLink = useWhatsAppLink();
  const galleryImages = [
    'https://customer-assets-cm19k8pv.emergentagent.net/job_preview-live-18/artifacts/707f6ed00a1c68c9_43c8fd464593bec0862d537d8b35e07b3398b922.webp',
    'https://customer-assets-cm19k8pv.emergentagent.net/job_preview-live-18/artifacts/d71a3983fad1d2dd_ed7f3df292277a31559d56bc30f8bd723db0325f.webp',
    'https://customer-assets-cm19k8pv.emergentagent.net/job_preview-live-18/artifacts/a98fa8a93016cb47_801f7fc874861d2319130bcf7feac93b81bc7bb9.webp',
    'https://customer-assets-cm19k8pv.emergentagent.net/job_preview-live-18/artifacts/e4532797539d3417_8c2b2174f703c7f05bd37e39dd11e76e079f36cf.webp',
    'https://customer-assets-cm19k8pv.emergentagent.net/job_preview-live-18/artifacts/baa297981af57c71_b56dbce087784a7e69829aa3c747413d8f29dec4.webp',
  ];

  const [selectedIndex, setSelectedIndex] = useState(null);
  const isOpen = selectedIndex !== null;

  const closeLightbox = () => setSelectedIndex(null);
  const showPrev = (e) => {
    e && e.stopPropagation();
    setSelectedIndex((i) => (i === 0 ? galleryImages.length - 1 : i - 1));
  };
  const showNext = (e) => {
    e && e.stopPropagation();
    setSelectedIndex((i) => (i === galleryImages.length - 1 ? 0 : i + 1));
  };

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') showPrev();
      else if (e.key === 'ArrowRight') showNext();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <div className="gallery-page">
      <div className="top-bar" />
      <div className="gallery-container">
        <h1 className="page-title">{t('gallery.title')}</h1>
        <p className="gallery-subtitle">{t('gallery.subtitle')}</p>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => setSelectedIndex(index)}
              data-testid={`gallery-item-${index}`}
            >
              <img src={image} alt={`Gallery ${index + 1}`} loading="lazy" />
              <div className="gallery-item-overlay">
                <span className="gallery-zoom-hint">{t('gallery.zoomHint')}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isOpen && (
        <div
          className="lightbox-overlay"
          onClick={closeLightbox}
          data-testid="lightbox-overlay"
        >
          <button
            className="lightbox-close"
            onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
            aria-label="Chiudi"
            data-testid="lightbox-close-btn"
          >
            <X size={28} />
          </button>

          <button
            className="lightbox-nav lightbox-prev"
            onClick={showPrev}
            aria-label="Precedente"
            data-testid="lightbox-prev-btn"
          >
            <ChevronLeft size={36} />
          </button>

          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img
              className="lightbox-image"
              src={galleryImages[selectedIndex]}
              alt={`Gallery full ${selectedIndex + 1}`}
              data-testid="lightbox-image"
            />
            <a
              href={whatsappLink}
              className="lightbox-book-btn"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="lightbox-book-btn"
            >
              <WhatsAppIcon size={18} />
              <span>{t('gallery.bookCta')}</span>
            </a>
          </div>

          <button
            className="lightbox-nav lightbox-next"
            onClick={showNext}
            aria-label="Successiva"
            data-testid="lightbox-next-btn"
          >
            <ChevronRight size={36} />
          </button>

          <div className="lightbox-counter">
            {selectedIndex + 1} / {galleryImages.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
